import { PriceAnalysisDataRow } from './price-analysis.types';

export function enrichPriceAnalysisRows(rows: PriceAnalysisDataRow[]): PriceAnalysisDataRow[] {
  return rows.map((row) => {
    const listPrice = Number(row.listPrice || 0);
    const transacted = row.customerTransactedPrice == null ? null : Number(row.customerTransactedPrice || 0);
    const discount = listPrice && transacted != null ? ((listPrice - transacted) / listPrice) * 100 : null;
    const configuredDiscount = Number(row.customerDiscountPercent);
    const equipment = String(row.equipment || '');
    const cpl = String(row.cpl || '');
    const countryCode = toCountryCode(String(row.country || ''));

    return {
      ...row,
      equipmentCpl: cpl ? `${equipment} - ${cpl}` : equipment,
      equipmentCountryLabel: [equipment, countryCode].filter(Boolean).join('-'),
      customerDiscountPercent: Number.isFinite(configuredDiscount) ? configuredDiscount : discount ?? undefined,
    };
  });
}

function toCountryCode(country: string): string {
  const countryCodes: Record<string, string> = {
    australia: 'AUS',
    canada: 'CAN',
    germany: 'DEU',
    india: 'IND',
    us: 'USA',
    usa: 'USA',
    'united states': 'USA',
    'united states of america': 'USA',
    brazil: 'BRA',
    chile: 'CHL',
    peru: 'PER',
    mexico: 'MEX',
    china: 'CHN',
    japan: 'JPN',
    'south africa': 'ZAF',
    indonesia: 'IDN',
  };

  const normalized = country.trim().toLowerCase();
  return countryCodes[normalized] || country.slice(0, 3).toUpperCase();
}
